// removed by extract-text-webpack-plugin
module.exports = {"menu-item":"Option__menu-item","menuItem":"Option__menu-item","menu-item-redesign":"Option__menu-item-redesign","menuItemRedesign":"Option__menu-item-redesign","menu-item-renny":"Option__menu-item-renny","menuItemRenny":"Option__menu-item-renny","menu-item-selected":"Option__menu-item-selected","menuItemSelected":"Option__menu-item-selected","seprater":"Option__seprater","disabled":"Option__disabled","radioIconButton":"Option__radioIconButton","renny-label":"Option__renny-label","rennyLabel":"Option__renny-label"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/Option/Option.css
// module id = 1244
// module chunks = 8